import { ACTION_SET_SEARCH_OPEN, type DisplayActionTypes } from '../types/display';

export function setSearchOpen(searchOpen: boolean): DisplayActionTypes {
    return {
        type: ACTION_SET_SEARCH_OPEN,
        searchOpen,
    };
}
